<div *ngIf="formData">
    <div *ngFor="let data of newFormData; let index = index" class="se-stepper-exam-card-container">
        <div *ngFor="let key of objectKeys(data); let ind = index" class="se-stepper-exam__item" [ngClass]="ind != 1 ? 'se-stepper-exam-text-long' : 'se-stepper-exam-text-short' ">
            <span class="se-stepper-exam__inner-container">
                <span #keyEl class="se-stepper-exam__key" matTooltip="{{key | translate}}" positionAtOrigin="true" [matTooltipDisabled]="_isTooltipDisabled(keyEl)">
                    {{key | translate}}
                </span>
            </span>
            <span class="se-stepper-exam__inner-container">
                <span #valueEl class="se-stepper-exam__value" [class.se-stepper-exam-text-description]="ind != 1" matTooltip="{{data[key] | translate}}" positionAtOrigin="true" [matTooltipDisabled]="_isTooltipDisabled(valueEl)">
                    {{data[key] | translate}}
                </span>
            </span>
        </div>
        <span>
            <button (click)="_deleteExam($event, data, index)" mat-icon-button color="primary" [disabled]="disableButton">
                <mat-icon>delete</mat-icon>
            </button>
        </span>
    </div>

</div>
